import React, { useState } from "react";
import { api, clp } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { TicketPercent, X } from "lucide-react";

export const montoCupon = (c, base) => {
  if (!c || base <= 0) return 0;
  return Math.round(c.tipo === "PERCENT" ? (base * Number(c.valor)) / 100 : Math.min(Number(c.valor), base));
};

/** Cupón de descuento en la pantalla de cobro (no se combina con el descuento manual). */
export default function CuponPOS({ value, onChange, base, storeId, bloqueado }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const aplicar = async () => {
    const c = code.trim().toUpperCase();
    if (!c) return;
    setBusy(true);
    try {
      const { data } = await api.post("/coupons/validate", { code: c, subtotal: base, canal: "POS", store_id: storeId });
      onChange(data.coupon); setCode("");
      toast.success(`Cupón ${data.coupon.code} aplicado`);
    } catch (e) { toast.error(e?.response?.status === 403 ? "Tu plan no incluye cupones" : (e?.response?.data?.detail || "Cupón inválido")); }
    setBusy(false);
  };
  if (value) {
    return (
      <div className="rounded-2xl border border-emerald-200 bg-emerald-50 px-3 py-2 flex items-center gap-2" data-testid="pos-cupon-aplicado">
        <TicketPercent className="w-4 h-4 text-emerald-700" />
        <p className="flex-1 text-sm font-bold text-emerald-800">Cupón {value.code} · -{clp(montoCupon(value, base))}
          <span className="font-normal text-emerald-700"> ({value.tipo === "PERCENT" ? `${value.valor}%` : clp(value.valor)})</span></p>
        <button type="button" onClick={() => onChange(null)} data-testid="pos-cupon-quitar" className="text-emerald-700 hover:text-emerald-900"><X className="w-4 h-4" /></button>
      </div>
    );
  }
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-2" data-testid="pos-cupon">
      <div className="flex gap-2">
        <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} disabled={bloqueado}
               onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); aplicar(); } }}
               placeholder={bloqueado ? "Sin cupón (hay descuento manual)" : "Código de cupón"}
               data-testid="pos-cupon-input"
               className="flex-1 min-w-0 h-10 rounded-xl border border-slate-200 px-3 text-sm font-mono-num uppercase disabled:bg-slate-50" />
        <Button type="button" disabled={bloqueado || busy || !code.trim()} onClick={aplicar} data-testid="pos-cupon-aplicar"
                className="h-10 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold">
          <TicketPercent className="w-4 h-4 mr-1" /> {busy ? "…" : "Aplicar"}
        </Button>
      </div>
    </div>
  );
}
